import {Route, Routes, Navigate} from 'react-router-dom';
import DashboardPage from '../pages/admin/DashboardPage';
import DatabasePage from '../pages/admin/DatabasePage';
import DocsPage from '../pages/admin/DocsPage';
import FaqEditPage from '../pages/admin/FaqEditPage';
import FaqPage from '../pages/admin/FaqPage';
import FeedbackPage from '../pages/admin/FeedbackPage';
import VocaPage from '../pages/admin/VocaPage';

export default function AdminRoutes() {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='/admin/dashboard' replace />} />
            <Route path='dashboard' element={<DashboardPage />}/>
            <Route path='database' element={<DatabasePage />} />
            <Route path='docs' element={<DocsPage />}/>
            <Route path='docs/:id' element={<DocsPage />} />
            <Route path='faq' element={<FaqPage />}/>
            <Route path='faq/new' element={<FaqEditPage mode='create' />} />
            <Route path='faq/:id' element={<FaqEditPage mode='edit' />} />
            <Route path='feedback' element={<FeedbackPage />}/>
            <Route path='voca' element={<VocaPage />} />
        </Routes>
    );
}
